import React from 'react';
import { Link } from 'react-router-dom';

const Imprint = () => (
  <div className="absolute h-9/12 flex justify-center items-center w-screen overflow-y-scroll text-white bg-black">
    <div className="h-full w-full min-w-0 px-5 break-words sm:w-2/3 sm:px-0">
      <h1 className="text-xl sm:text-3xl my-5">Impressum</h1>
      <p className="italic mb-5">
        Angaben gemäß{' '}
        <a
          className="text-yellow underline"
          href="https://www.gesetze-im-internet.de/ddg/__5.html"
        >
          § 5 Digitale-Dienste-Gesetz (DDG)
        </a>
        .
      </p>
      <div>
        <p>
          Fahrschule Untern Buchen
          <br />
          Eisenbahnstraße 31
          <br />
          16225 Eberswalde
          <br />
          Deutschland
        </p>
        <p className="my-5">
          <span className="underline">Vertreten durch:</span> André Zieroth
        </p>
        <p className="my-5">
          <span className="underline">Tel.:</span>{' '}
          <a className="text-yellow" href="tel:+493334385256">
            03334 385256
          </a>
        </p>
        <p className="my-5">
          <span className="underline">E-Mail:</span>{' '}
          <a className="text-yellow" href="mailto:kontakt@unternbuchen.de">
            kontakt@unternbuchen.de
          </a>
        </p>
        <p className="my-5">
          <span className="underline">Umsatzsteuer-Nummer:</span> 065-279-00679
        </p>
        <p className="my-5">
          <span className="underline">Aufsichtsbehörde:</span>
          <br />
          Zulassungs- und Fahrerlaubnisbehörde Landkreis Barnim
          <br />
          Am Markt 1 / Pfeilstraße
          <br />
          16225 Eberswalde
        </p>
      </div>
      <h2 className="text-lg sm:text-xl mb-5">Verbraucherstreitbeilegung</h2>
      <p>
        Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren
        vor einer Verbraucherschlichtungsstelle teilzunehmen.
      </p>
      <h2 className="text-lg sm:text-xl mt-10 mb-5">Haftungsausschluss</h2>
      <h3 className="text-lg mt-5">Haftung für Inhalte</h3>
      <p>
        Für eigene Inhalte auf diesen Seiten sind wir nach den allgemeinen
        Gesetzen verantwortlich. Bei Hinweisen auf konkrete Rechtsverletzungen
        prüfen wir die betroffenen Inhalte und ergreifen die erforderlichen
        Maßnahmen.
      </p>
      <h3 className="text-lg mt-5">Haftung für Links</h3>
      <p>
        Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren
        Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden
        Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten
        Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten
        verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der
        Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte
        waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente
        inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete
        Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden
        von Rechtsverletzungen werden wir derartige Links umgehend entfernen.
      </p>
      <h2 className="text-lg sm:text-xl mt-10 mb-5">Urheberrecht</h2>
      <p>
        Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen
        Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung,
        Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der
        Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des
        jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite
        sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.
        Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden,
        werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte
        Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine
        Urheberrechtsverletzung aufmerksam werden, bitten wir um einen
        entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden
        wir derartige Inhalte umgehend entfernen.
      </p>
      <h2 className="text-lg sm:text-xl mt-10 mb-5">Datenschutz</h2>
      <p>
        Informationen zur Verarbeitung personenbezogener Daten findest du in
        unserer{' '}
        <Link className="text-yellow underline" to="/datenschutz">
          Datenschutzerklärung
        </Link>
        .
      </p>
      <p className="my-5">
        Impressum vom
        <a className="text-yellow" href="https://www.impressum-generator.de">
          {' '}
          Impressum Generator{' '}
        </a>
        der
        <a
          className="text-yellow"
          href="https://www.kanzlei-hasselbach.de/standorte/bonn/"
        >
          {' '}
          Kanzlei Hasselbach, Bonn{' '}
        </a>
      </p>
    </div>
  </div>
);

export default Imprint;
